package kampfire.model

/** Whether a scrolled element is at its start or its end. */
data class ScrollState(
    val atStart: Boolean,
    val atEnd: Boolean
)